module.exports = __webpack_public_path__ + "img/sw05.af5e84fc.jpg";